import {USER_MANAGE, USER_INFO} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/user/access/index.vue'),
    name: USER_MANAGE,
    path: 'user',
    meta: {
        name: USER_MANAGE,
        title: '用户管理'
    }
};

export const UserInfo = {
    component: () => import('@/views/user/info/UserInfo.vue'),
    name: USER_INFO,
    path: 'userInfo',
    meta: {
        name: USER_INFO,
        title: '个人信息'
    }
};